import React from "react";

import { cn } from "@/lib/utils";
import { haptic } from "@/lib/haptics";

/**
 * Floating action button, pinned bottom-right above the safe area (and above
 * the tab bar when `aboveTabBar`). Phones only: pass `className="md:hidden"`
 * semantics by only rendering it on mobile layouts.
 */
export default function Fab({
  icon: Icon,
  label,
  onClick,
  aboveTabBar = false,
  tone = "dark", // "dark" | "accent"
  extended = false, // show the label next to the icon
  className,
  testId,
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      aria-label={label}
      onClick={(e) => {
        haptic("light");
        onClick?.(e);
      }}
      style={{
        bottom: aboveTabBar
          ? "calc(var(--tabbar-h) + env(safe-area-inset-bottom, 0px) + 16px)"
          : "calc(env(safe-area-inset-bottom, 0px) + 16px)",
        right: "calc(env(safe-area-inset-right, 0px) + 16px)",
      }}
      className={cn(
        "fixed z-30 flex h-14 items-center justify-center gap-2 rounded-full text-white shadow-[0_8px_24px_rgba(0,0,0,0.28)] transition-transform active:scale-95",
        extended ? "min-w-14 px-5" : "w-14",
        tone === "accent" ? "bg-[#E05236] active:bg-[#C94A31]" : "bg-neutral-950 active:bg-neutral-800",
        className
      )}
    >
      <Icon className="h-6 w-6" strokeWidth={2} />
      {extended && <span className="text-sm font-semibold">{label}</span>}
    </button>
  );
}
